// Core
import React, { lazy, useEffect, useState } from 'react';
import {
  Card, Row, Col, Table, Spin, Tooltip, Modal, notification, Form, Input, Button, Divider
} from 'antd';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Moment from 'moment';
import 'moment/locale/es-mx';
import { SearchOutlined } from '@ant-design/icons';

// App
import {
  pacienteReadAction,
  pacienteServicioCreateAction,
  pacienteServicioListAction
} from '../../../redux/clinica/pacientes/actionCreator';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { TableWrapper } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import BuscadorProductosServicios from '../conceptos/BuscadorCatalogo';
import PacienteConceptosView from '../conceptos/PacienteConceptos';
import { TipoTransaccion } from './../../../config/api/enums';
const { Search } = Input;

const PresupuestoView = ({ setSubmenu }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registro = useSelector(state => state.PacienteReducer.record);
  const compras = useSelector(state => state.PacienteReducer.compras);
  const { id } = useParams();
  const [nombre, setNombre] = useState('Cargando...');

  useEffect(() => {
    if (id) dispatch(pacienteReadAction(id));
    else
      dispatch(pacienteReadAction());
  }, [id]);

  useEffect(() => {
    if (registro.id) {
      let elNombre = registro.nombre.toUpperCase() + ' ' + registro.paterno.toUpperCase() + ' ' + registro.materno.toUpperCase()
      setNombre(elNombre);
    }
  }, [registro]);

  useEffect(() => {

  }, [dispatch]);

  const handleServicio = async (registro) => {
    console.log('resupuesto.handleServicio: ', registro.record);
    const params = {
      action: 'presupuesto',     
      id: 0,
      idServicio: registro.record.id,
      idPaciente: id,
      idTipoTransaccion: TipoTransaccion.Presupuesto,
      idRecepcionista: 0,
      idDentista: 1,
    };
    const responseApi = await dispatch(pacienteServicioCreateAction(params));
    if (responseApi) {
      let mensaje = 'Servicio agregado al presupuesto';
      notification.success({
        message: mensaje,
      });
      // Recargar lista de servicios en presupuesto
      dispatch(pacienteServicioListAction(id, TipoTransaccion.Presupuesto));
    } else {
      notification.error({
        message: 'Error al procesar presupuesto',
      });
    }
  };


  return (
    <>
      <Card>
        <PageHeader
          title="Presupuesto"
          subTitle={"Elaborado para: " + nombre}
          buttons={[
            <Button className="btn-add_new noprint" size="default" key="2" type="primary">
              <Link to={`/admin/clinica/pacientes/expediente/${id}`}> Volver al expediente</Link>
            </Button>,
          ]}
        />
        <BuscadorProductosServicios callbackAction={handleServicio} /> <br />
        <Divider plain>Los siguientes conceptos han sido incluidos al presupuesto del paciente</Divider>
        <PacienteConceptosView pacienteId={id} tipoTransaccionId={TipoTransaccion.Presupuesto} vista='presupuesto' tipoCompra='' />
        <Row gutter={24} justify="space-around" align="middle">
          <Col span={6}>SUBTOTAL: <strong>${compras?.totales?.total_subtotal}</strong></Col>
          <Col span={6}>DESCUENTO: <strong>${compras?.totales?.total_descuento}</strong></Col>
          <Col span={6}>TOTAL: <strong>${compras?.totales?.total_total}</strong></Col>          
        </Row>
      </Card>
      

    </>
  );
};

export default PresupuestoView;
